module.exports = __webpack_public_path__ + "img/icono-volver.1394ecb8.svg";